import { RuleListModel } from '../../models/RuleListModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const DISABLE_RULE = '[Rule] Rule Disable';

export class DisableRuleAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = DISABLE_RULE;

  constructor(public payload: { rule: RuleListModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/DisableRuleAction.ts